<template>
  <div class="titulo-lateral">
    <h2>{{ titulo }}</h2>
    <a v-if="temBotao" :href="link">VER MAIS</a>
  </div>
</template>

<script>
export default {
  name: 'TituloLateral',
  props: {
    titulo: {
      default: 'Título de Sessão',
      type: String,
    },
    link: {
      default: '#',
      type: String,
    },
    temBotao: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.titulo-lateral {
  @extend %flex;
  @extend %direction-row;
  @extend %align-items-center;
  margin-bottom: 12px;
  user-select: none;

  & h2 {
    font-family: 'VivoType';
    font-size: 22px;
    letter-spacing: 0px;
    padding-right: 15px;
    color: $cor_roxo;
    text-transform: uppercase;
    margin: 0px;
    padding: 0 25px;
    font-weight: bold;
  }

  & a {
    color: white;
    font-size: 12px;
    font-family: 'OpenSans';
    text-decoration: none;
    padding: 2px 10px;
    border-radius: 5px;
    background: $cor_amarelo;
    @extend %nao-selecionavel;

    &:hover {
      background: $cor_roxo;
      -webkit-box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
      -moz-box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
      box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
    }
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
}
</style>
